import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'

@Component({
  selector: 'app-tax-forms',
  templateUrl: './tax-forms.component.html',
  styleUrls: ['./tax-forms.component.scss']
})
export class TaxFormsComponent implements OnInit {

  constructor(private _router: Router) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-settings-v/tax-forms/tax-forms.component.ts